import React, { Component, Fragment } from 'react';

class LetterOfAppealDownload extends Component {

    render() {
        const { pdfUrl } = this.props;

        return (
            <Fragment>
                <p>You have successfully completed the letter of appeal template.</p>
                <p>Download a copy to save for your records.</p>
                <div className="grid">
                    <div className="row">
                        <div className="col-md-12">
                            <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="button blue button-spacing" >
                                Download PDF
                            </a>
                        </div>
                        <div className="col-md-12">
                            <a href="/nuplazid/healthcare-providers">
                                Return to homepage
                            </a>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

  export default LetterOfAppealDownload;
